<template>
    <div class="memorandum_create_block small">
        <!-- create menu_draw -->
        <div class="list_mem_create">
            <div class="panel ">
                <div class="panel-hdr bg-primary-500 bg-success-gradient">
                    <h2>
                        <span class="icon-stack fs-xxl mr-2">
                            <i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
                            <i class="base base-7 icon-stack-2x opacity-100 color-primary-400"></i>
                            <i class="fal  fa-people-arrows icon-stack-1x opacity-100 color-white fa-spin"></i>
                        </span>
                        Переміщення користувача
                    </h2>
                    <div class="panel-toolbar">
                        <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen"
                                data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
                    </div>
                </div>
                
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="user_add" v-if="!obj_to_null(this.user)">
                            <div class="add user cursor-pointer fs-xxl" @click="add_user">
                                <i title="" class="fal add_user fa-plus-square color-primary-100 pr-3"
                                   data-type="delegate_users"></i>
                                <span>Оберіть користувача</span>
                            </div>
                        </div>
                        
                        <div class="row" v-if="obj_to_null(this.user)">
                            <div class="col-6 col-lg-6 col-md-5 col-xs-12">
                                <b-card no-body>
                                    
                                    <template v-slot:header>
                                        <h4 class="mb-0">Переміщення з </h4>
                                    </template>
                                    
                                    <b-card-body>
                                       
                                        <user_block v-if="obj_to_null(this.user)"
                                                    :key="user.id"
                                                    v-bind:can_del=true
                                                    v-bind:del_triger="remove_selected_user"
                                                    v-bind:user="user">
                                        </user_block>
                                        
                                        <div class="next_step pt-3">
                                            <button class="btn btn-lg btn-outline-primary" :disabled="!can_save" v-on:click="save">
                                                Створити
                                            </button>
                                        </div>
                                    </b-card-body>
                                </b-card>
                            </div>
                            
                            <div class="col-6 col-lg-6 col-md-5 col-xs-12">
                                <b-card no-body>
                                    <template v-slot:header>
                                        <h4 class="mb-0">Переміщення в </h4>
                                    </template>
                                    
                                    <b-card-body>
                                        <b-row class="doc_title">
                                            <b-col sm="3">
                                                <label for="srv_lst">Кластер *</label>
                                            </b-col>
                                            
                                            <b-col sm="4">
                                                <b-form-select id="srv_lst" v-model="form.cluster_id"
                                                  :options="form.srv_list" required>
                                                </b-form-select>
                                            </b-col>
                                        </b-row>
                                        
                                        <b-row class="doc_title">
                                            <b-col sm="3">
                                                <label for="u_dep">Організація *</label>
                                            </b-col>
                                            <b-col sm="4">
                                                <b-form-select
                                                    id="srv_lst" v-model="form.company"
                                                    :options="form.company_list" required>
                                                    
                                                </b-form-select>
                                            </b-col>
                                        </b-row>
                                        
                                        <b-row class="doc_title">
                                            <b-col sm="3">
                                                <label for="u_dep">Вiддiл *</label>
                                            </b-col>
                                            <b-col sm="4">
                                                <b-form-input v-model="form.department" maxlength="120" id="u_dep"
                                                              size="sm"></b-form-input>
                                            </b-col>
                                        </b-row>
                                        
                                        <b-row class="doc_title">
                                            <b-col sm="3">
                                                <label for="u_dep">Посада *</label>
                                            </b-col>
                                            
                                            <b-col sm="4">
                                                <b-form-input v-model="form.dolznost" maxlength="120" id="u_dep"
                                                              size="sm"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-card-body>
                                </b-card>
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import user_block from "../../../shared/user/user_block/user_block.vue";

export default {
    name: "hr_move",
    components: {
        user_block
    },
    data() {
        return {
            uniq_u: 'fire_user_add',
            remove_selected_user: "remove_user",
            user: {},
            form: {
                user_id: 0,
                cluster_id: 0,
                srv_list: [],
                company_list: [],
                company: "",
                department: "",
                dolznost: "",
            }
        }
    },
    
    created() {
        EventBus.$on('selected_users', this.load_selected_user);
        EventBus.$on(this.remove_selected_user, e => {
            this.user = null;
            this.form = {
                srv_list: [],
                user_id: 0,
                cluster_id: 0,
                company: "",
                department: "",
                dolznost: "",
            }
        });
    },
    
    beforeDestroy() {
        EventBus.$off("selected_users", this.load_selected_user);
    },
    
    methods: {
        
        async save() {
            IMC_CORE.showloading();
            
            api.put('/hr/move/' + this.user.id, this.form)
                .then(({data}) => {
                    IMC_CORE.hideloading();
                    if (data.status === "operation_success") {
                        if (data.message !== undefined) {
                            IMC_CORE.snackbar("OK")
                            this.user = null;
                            this.form = {
                                user_id: 0,
                                cluster_id: 0,
                                srv_list: [],
                                company: "",
                                department: "",
                                dolznost: "",
                            }
                        }
                    } else {
                        EventBus.$emit('show_toast', {err: data.message, type: "danger", title: data.status})
                    }
                }).catch(err => {
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        
        load_selected_user(e) {
            if (e.uniq === this.uniq_u) {
                EventBus.$emit('close_u_filter');
                this.load_user_info(e.users[0]);
            }
        },
        
        
        async load_user_info(user) {
            console.log('user_selected',user);
            IMC_CORE.showloading();
            
            await api.get('/hr/move/' + user.id)
                .then(({data}) => {
                    IMC_CORE.hideloading();
                    if (data.status === "operation_success") {
                        if (data.message !== undefined) {
                            this.user = data.data;
                            this.form = data.message;
                        }
                    } else {
                        EventBus.$emit('show_toast', {err: data.message, type: "danger", title: data.status})
                    }
                }).catch(err => {
                    IMC_CORE.hideloading();
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
        },
        
        add_user() {
            EventBus.$emit('load_users_filter', {
                    uniq: this.uniq_u,
                    active: [],
                }
            );
        },
    },
    
    computed : {
        can_save() {
            if(this.form.dolznost.length <= 0) {
                return false;
            }
            
            if(this.form.department.length <= 0) {
                return false;
            }
            
            if(parseInt(this.form.cluster_id) <= 0) {
                return false;
            }
            
            if(this.form.company.length <= 0) {
                return false;
            }
            return true;
        },
    }
}
</script>

<style scoped>
.doc_title {
    margin-bottom: 15px;
}

.doc_title label {
    font-size: 15px;
}


</style>
